import { Button, EmptyState, PageHeader } from '@gestao/ui'
import { Lock } from 'lucide-react'
import { Link } from 'react-router'

import { usePageTitle } from '../../app/use-page-title'
import * as t from '../../i18n/pt-BR'

/** Rota protegida sem a permissão do perfil. */
export function NoAccessPage() {
  usePageTitle(t.noAccess.title)

  return (
    <div className="flex flex-col gap-8">
      <PageHeader title={t.noAccess.title} />
      <EmptyState icon={<Lock />} title={t.noAccess.heading} description={t.noAccess.description}>
        <Button asChild variant="secondary">
          <Link to="/">{t.common.backHome}</Link>
        </Button>
      </EmptyState>
    </div>
  )
}
